import { render } from "./PaasReviewModal.vue?vue&type=template&id=9dfae48e"
import script from "./PaasReviewModal.vue?vue&type=script&lang=js"
export * from "./PaasReviewModal.vue?vue&type=script&lang=js"

import exportComponent from "/builds/vrs/docker/web/app/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__